export var MessageSender;
(function (MessageSender) {
    MessageSender["APP"] = "app";
    MessageSender["PARTNER"] = "partner";
})(MessageSender || (MessageSender = {}));
